<template>
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead class="table-light">
        <tr>
          <th v-for="column in columns" :key="column.key" :style="{ minWidth: column.minWidth + 'px' }">
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td v-if="item.isFirstInGroup" :rowspan="item.childrenCount" class="align-middle">
            {{ item.originalParent }}
          </td>
          <td>{{ item.childCategory }}</td>
          <td>
            <div class="radio-container">
              <div class="radio-option">
                <input
                  type="radio"
                  :name="`inventory_${item.childId}`"
                  :id="`target_${item.childId}`"
                  :value="1"
                  :checked="item.isInventory === 1"
                  @change="updateInventoryStatus(item.childId, 1)"
                />
                <label :for="`target_${item.childId}`">対象</label>
              </div>
              <div class="radio-option">
                <input
                  type="radio"
                  :name="`inventory_${item.childId}`"
                  :id="`non_target_${item.childId}`"
                  :value="0"
                  :checked="item.isInventory === 0"
                  @change="updateInventoryStatus(item.childId, 0)"
                />
                <label :for="`non_target_${item.childId}`">対象外</label>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'InventoryCategoryTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  methods: {
    updateInventoryStatus(childId, isInventory) {
      this.$emit('update', childId, isInventory);
    }
  }
}
</script>

<style scoped>
.table th {
  padding: 0.75rem;
  text-align: left;
  background-color: #195983;
  color: white;
  border: 1px solid #dee2e6;
  white-space: nowrap;
}

.radio-container {
  display: flex;
  flex-wrap: wrap;
}

.radio-option {
  margin-right: 15px;
  display: flex;
  align-items: center;
  font-weight: 700;
}

.radio-option input[type="radio"] {
  margin-right: 5px;
}

.align-middle {
  vertical-align: middle !important;
}
</style>
